import styled from 'styled-components';

export const BookingCardMainWrap = styled.div(
    props => `
      width:100%;
      display: flex;
      padding-left: ${props.theme.spacing.large.l30};
      margin-bottom: ${props.theme.spacing.large.l20};
      position: relative;
    `
);

export const BookingCardOuterWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      background-color: ${props.theme.colors.white.base};
      border-radius: 0.5rem;
      box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
      position: relative;
  `
);

export const BookingCardInnerWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
  `
);

export const BookingCardHeaderWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l55};
      box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  `
);


export const BookingCardInfoWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l55};
  `
);
